/* rr-theme-toggle.js - the light/dark control in the header utility row.

   WHY IT IS INJECTED RATHER THAN TEMPLATED
   sections/header.liquid is 50 KB and Shopify's file API has no patch - adding
   one list item means re-sending the whole file and owning it forever. This
   finds .header__utils-items and inserts the control as the first item, ahead
   of the country selector, so it sits in the same cluster as country, search,
   account and cart without touching the section.

   MOBILE. 21 Aug: the control was invisible below 750px. Not a CSS bug of
   ours - `assets/section-header.css:327` hides EVERY utility item that does
   not opt in:

       .header__utils-item:not(.header__utils-item--mobile){ display: none; }
       @media (min-width: 750px){ .header__utils-item:not(...--cart){ display: flex } }

   Search, account and cart all carry `header__utils-item--mobile` in
   header.liquid (lines 508, 513, 527). The injected item did not, so it was
   display:none on 88% of sessions. It carries the modifier now.

   NOT ON THE HOME PAGE. The index template is the brand statement and stays
   dark, so the choice is not offered there rather than offered and ignored.
   snippets/css.liquid makes the matching decision at the pre-paint step, so a
   customer who chose light mode gets a dark home page and their preference
   back on the next page - no flash either way.

   It carries ONLY .rr-theme-toggle. An earlier version also applied the
   theme's .header__utils-link and .text-link classes, which brought a border
   and a persistent focus box - the square parked around the icon.
*/
(function () {
  'use strict';

  var KEY = 'rr-theme';
  var root = document.documentElement;

  function isHome() {
    return document.body && document.body.classList.contains('template--index');
  }

  function current() {
    return root.getAttribute('data-rr-theme') === 'light' ? 'light' : 'dark';
  }

  function apply(next, btn) {
    if (next === 'light') root.setAttribute('data-rr-theme', 'light');
    else root.removeAttribute('data-rr-theme');
    try { localStorage.setItem(KEY, next); } catch (e) {}
    if (btn) label(btn, next);
  }

  function label(btn, mode) {
    var to = mode === 'light' ? 'dark' : 'light';
    btn.setAttribute('aria-pressed', mode === 'light' ? 'true' : 'false');
    btn.setAttribute('title', 'Switch to ' + to + ' mode');
    var sr = btn.querySelector('.rr-theme-toggle__sr');
    if (sr) sr.textContent = 'Switch to ' + to + ' mode';
  }

  function build() {
    if (isHome()) return;

    var list = document.querySelector('.header__utils-items');
    if (!list || list.querySelector('.rr-theme-toggle')) return;

    var li = document.createElement('li');
    /* `--mobile` is the opt-in that section-header.css:327 requires. Without it
       the item is display:none below 750px. Do not remove it. */
    li.className = 'header__utils-item header__utils-item--theme header__utils-item--mobile';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rr-theme-toggle';
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" ' +
      'stroke-width="1.4" stroke-linecap="square" aria-hidden="true" focusable="false">' +
        '<circle cx="12" cy="12" r="8"/>' +
        '<path d="M12 4a8 8 0 0 0 0 16z" fill="currentColor" stroke="none"/>' +
      '</svg>' +
      '<span class="rr-theme-toggle__sr visually-hidden"></span>';

    btn.addEventListener('click', function () {
      apply(current() === 'light' ? 'dark' : 'light', btn);
      btn.blur();
    });

    label(btn, current());
    li.appendChild(btn);
    list.insertBefore(li, list.firstElementChild);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }

  document.addEventListener('shopify:section:load', function () { setTimeout(build, 0); });
})();
